import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type { LeadsListParams } from 'app/features/leads/services/gym-finder/types';
import type { GymFinderService } from 'app/features/leads/services/gym-finder';

type LeadsListService = Pick<GymFinderService, 'listLeads'>;

export const leadsListQueryOptions = (service: LeadsListService, params: LeadsListParams) =>
  queryOptions({
    queryKey: ['leads', 'list', params],
    queryFn: () => service.listLeads(params),
    placeholderData: keepPreviousData,
  });
